import { getElements } from "js-utils/src/selector";
import { addClass, removeClass } from "js-utils/src/attribute";
import { addEventListener } from "js-utils/src/event";
import Fuse from "fuse.js";

import init from "../../common/base/init";

// overflows
init(() => {
  const overflowTriggers = getElements('.js--show-overflow');

  if (!overflowTriggers) return;

  overflowTriggers.forEach((trigger) => {
    addEventListener(trigger, 'click', (e) => {
      e.preventDefault;

      const overflowContainer = trigger.parentNode;

      overflowContainer.classList.remove("js--overflow");
    });
  });
});

// bookmark options context menu

init(() => {
  if (!document.querySelector(".library-wrap")) return;

  document.addEventListener("click", e => {
    const toggle = e.target.closest(".library-wrap .-options .-toggle");
    let opened = false;

    if (toggle) {
      opened = toggle.closest(".-options").classList.contains("--open");
    }

    removeClass(".library-wrap .-options.\\--open", "--open");

    if (toggle && !opened) {
      toggle.closest(".-options").classList.add("--open");
    }
  });
});

// move bookmark cta

init(() => {
  const toggles = document.querySelectorAll(".library-wrap .-options .-move");
  if (!toggles.length) return;

  let formAction = null;
  addEventListener(toggles, "click", e => {
    e.preventDefault();

    const toggle = e.currentTarget;
    const modal = document.querySelector(".library-save");
    const modalTitle = modal.querySelector(".-title");
    const form = modal.querySelector(".-form");
    const idInput = form.querySelector("#bookmark_content_id");
    const row = toggle.closest("tr");
    const bookmarkId = row.dataset.id;
    const bookmarkTitle = row.dataset.title;

    formAction = formAction || form.action;
    form.action = `${formAction}/${bookmarkId}`;
    modalTitle.innerHTML = bookmarkTitle;
    idInput.value = bookmarkId;
  });
});

// edit bookmark cta

init(() => {
  const toggles = document.querySelectorAll(".library-wrap .-options .-edit");
  if (!toggles.length) return;

  let formAction = null;
  addEventListener(toggles, "click", e => {
    e.preventDefault();

    const toggle = e.currentTarget;
    const row = toggle.closest("tr");
    const bookmarkId = row.dataset.id;
    const bookmarkTitle = row.dataset.title;
    const modal = document.querySelector(".library-edit");
    const form = modal.querySelector(".-form");
    const nameInput = modal.querySelector("#bookmark_content_title");
    const idInput = modal.querySelector("#bookmark_content_id");

    formAction = formAction || form.action;
    form.action = `${formAction}${bookmarkId}`;
    nameInput.value = bookmarkTitle;
    idInput.value = bookmarkId;
  });
});

// save/move modal: conditional field toggle

init(() => {
  const containers = getElements(".library-save");
  if (!containers) return;

  containers.forEach(container => {
    const form = container.querySelector(".-form");
    const folderDropdown = container.querySelector(
      ".-bookmark-folder-input"
    );

    const sectionDropdown = container.querySelector(
      ".-bookmark-section-input"
    );

    const mainSectionChoice = {
      id: "",
      title: sectionDropdown ? sectionDropdown.dataset.labelMain : "",
      selected: true
    };

    const newSectionChoice = {
      id: "0",
      title: sectionDropdown ? sectionDropdown.dataset.labelNew : ""
    };

    const newFolderName = container.querySelector(
      ".-new-folder-name"
    );

    const sectionContainer = container.querySelector(
      ".-bookmark-section"
    );

    const newSectionName = container.querySelector(
      ".-new-section-name"
    );

    if (folderDropdown) {
      folderDropdown.addEventListener(
        "change",
        e => {
          removeClass(newSectionName, "--visible");
          sectionDropdown.CHOICES_INSTANCE.clearStore();

          if (e.detail.value === "0") {
            addClass(newFolderName, "--visible");
            sectionDropdown.CHOICES_INSTANCE.setChoices(
              [mainSectionChoice, newSectionChoice],
              "id",
              "title",
              true
            );
          } else {
            addClass(sectionContainer, "--visible");
            removeClass(newFolderName, "--visible");

            fetch(`/bibliotek/${e.detail.value}.json`)
              .then(resp => resp.json())
              .then(resp => {
                const sections = [
                  mainSectionChoice,
                  ...resp.sections,
                  newSectionChoice
                ];
                sectionDropdown.CHOICES_INSTANCE.setChoices(
                  sections,
                  "id",
                  "title",
                  true
                );
              })
              .catch(() => {
                alert('Error. Please and try again.');
                form.reset();
              });
          }
        },
        false
      );
    }

    if (sectionDropdown) {
      sectionDropdown.addEventListener(
        "addItem",
        e => {
          newSectionName.classList.toggle("--visible", e.detail.value === "0");
        },
        false
      );
    }
  });
});

// save/move modal: reset form on close

init(() => {
  const modal = document.querySelector("#library-save-form-modal");
  if (!modal || !modal.A11yDialogInstance) return;

  const form = modal.querySelector(".-form");

  modal.A11yDialogInstance.on("hide", () => {
    form.reset();
    const newInputs = document.querySelectorAll(
      ".-new-folder-name, .-new-section-name"
    );
    removeClass(newInputs, "--visible");
  });
});

init(() => {
  const modal = document.querySelector("#library-save-highlight-modal");
  if (!modal || !modal.A11yDialogInstance) return;

  const form = modal.querySelector(".-form");

  modal.A11yDialogInstance.on("hide", () => {
    form.reset();
    const newInputs = document.querySelectorAll(
      ".-new-folder-name, .-new-section-name"
    );
    removeClass(newInputs, "--visible");
  });
});

// save/move form submission: basic validation

init(() => {
  const form = document.querySelector(".library-save .-form");
  if (!form) return;

  const submitButton = form.querySelector('input[type="submit"]');
  const reenableBtn = () =>
    setTimeout(() => (submitButton.disabled = false), 200);

  form.addEventListener("submit", e => {
    const newFolderInput = form.querySelector(
      ".-new-folder-name.\\--visible input"
    );
    if (newFolderInput && newFolderInput.value == "") {
      e.preventDefault();
      reenableBtn();
    }

    const newSectionInput = form.querySelector(
      ".-new-section-name.\\--visible input"
    );
    if (newSectionInput && newSectionInput.value == "") {
      e.preventDefault();
      reenableBtn();
    }
  });
});

init(() => {
  const library_content = getElements(".js--search-titles");
  const library_sections = getElements(`div[data-section-id].-section`);
  const library_bookmarks = getElements(".js--search-titles tr[data-title]");
  if (!library_content.length) return;
  const searchData = [];

  library_bookmarks.map(bookmark => {
    searchData.push({
      id: bookmark.getAttribute("data-id"),
      title: bookmark.getAttribute("data-title"),
      section: bookmark.getAttribute("data-section")
    });
  });

  const fuse = new Fuse(searchData, {
    threshold: 0.4,
    keys: ["title"]
  });

  addEventListener(".js--searchbox", "input", e => {
    const searchTerm = e.currentTarget.value;
    removeClass(library_bookmarks, 'is-hidden');
    addClass(library_sections, 'open');
    removeClass(library_sections, 'closed');

    if (searchTerm.length < 3) return;

    const matchingItems = fuse.search(searchTerm);

    addClass(library_bookmarks, 'is-hidden');
    removeClass(library_sections, 'open');
    addClass(library_sections, 'closed');
    matchingItems.map(item => {
      const row = getElements(`tr[data-id="${item.id}"]`);
      const section = getElements(`div[data-section-id="${item.section}"].-section`);
      removeClass(row, 'is-hidden');
      removeClass(section, 'closed');
      addClass(section, 'open');
    })
  });
});
